import { SelectedItemButtonContainerContentProps } from './selectedItemButtonContainerContentProps';

const SelectedItemButtonContainerContent = <T extends unknown>({
  styles,
  selectedItem,
  onRenderSelectedItem
}: SelectedItemButtonContainerContentProps<T>) => {
  return (
    <div className={styles.mainContainerDivStyles}>
      {onRenderSelectedItem && selectedItem
        ? onRenderSelectedItem(selectedItem)
        : null}
      <i
        className={`ra-icons-generic-down-arrow ${styles.angleDownIconStyles}`}
      ></i>
    </div>
  );
};

export default SelectedItemButtonContainerContent;
